import { useEffect, useState } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { useSelector } from "react-redux";
import { Channels, IChannel } from "@ts/common-types";
import { FaExternalLinkSquareAlt } from "react-icons/fa";
import { getProductPageLink } from "@/ts/utils";

const ProductPageLinkButtonRenderer = (params: ICellRendererParams) => {
    // Temporarily disabled
    const channelDomain = useSelector((state: IChannel) => state.channelDomain.value);
    const channel = useSelector((state: IChannel) => state.channel.value);
    const [productLink, setProductLink] = useState("");

    useEffect(() => {
        const linkUrl = getProductPageLink(
            channel,
            params?.data?.asin,
            channelDomain,
            params?.data?.sku_title
        );
        setProductLink(linkUrl);
    }, [channel]);


    if (params.node.rowPinned) {
        return null;
    }
    return (
        <>
            {params.node.rowPinned ? null : (
                <div
                    onClick={() => window.open(productLink)}
                    style={[Channels.AMAZON, Channels.BLINKIT].includes(channel) ? { cursor: "pointer"} : { pointerEvents: "none", opacity: "0.6" }}
                >
                    <FaExternalLinkSquareAlt />
                </div>
            )}
        </>
    );
};

export default ProductPageLinkButtonRenderer;
